const UploadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='29.92'
      height='28.556'
      viewBox='0 0 29.92 28.556'
    >
      <g
        id='Group_6911'
        data-name='Group 6911'
        transform='translate(-324.023 -407.388)'
      >
        <path
          id='Path_14464'
          data-name='Path 14464'
          d='M353.764,420.935a7.5,7.5,0,0,0-6.955-5.511h-1.17a10.96,10.96,0,0,0-20.429-1.881c-1.842,3.836-1.5,9.775.759,13.24a.7.7,0,0,0,1.172-.765c-1.989-3.047-2.294-8.483-.677-11.852a9.565,9.565,0,0,1,17.954,2.119.7.7,0,0,0,.682.539h1.678a6.091,6.091,0,0,1,5.625,4.439,6.86,6.86,0,0,1-.908,5.052.7.7,0,0,0,.223.965.687.687,0,0,0,.37.107.7.7,0,0,0,.6-.329A8.289,8.289,0,0,0,353.764,420.935Z'
          fill='#4b9ce2'
        />
        <path
          id='Path_14465'
          data-name='Path 14465'
          d='M339.46,421.91a.72.72,0,0,0-.99,0l-5.7,5.706a.7.7,0,0,0,.99.99l4.515-4.516c0,.01,0,.018,0,.027v11.127a.7.7,0,1,0,1.4,0V424.117c0-.009-.005-.017-.005-.027l4.517,4.516a.7.7,0,0,0,.99-.99Zm-.495,1.507c-.01,0-.018.005-.027.005l.027-.026.027.026C338.982,423.422,338.974,423.417,338.965,423.417Z'
          fill='#4b9ce2'
        />
      </g>
    </svg>
  );
};

export default UploadIcon;
